import { Button } from '@mui/material';
import { Delete, Edit, Event, Payments } from '@mui/icons-material';
import { Card } from '../../users/details/Card';
import { InfoRow } from '../../users/details/InfoRow';
import { formatDateOnly } from '../../Formatters';
import { priceWithPending } from '../status';

interface Props {
  prices: { label: string; current?: number | null; next?: number | null }[];
  pendingFrom?: string | null;
  cancelling?: boolean;
  canChange: boolean;
  onChange(): void;
  onCancel(): void;
}

export function PriceCard({ prices, pendingFrom, cancelling, canChange, onChange, onCancel }: Props) {
  return (
    <Card
      title="Pris"
      action={
        pendingFrom ? (
          <Button size="small" color="warning" startIcon={<Delete />} disabled={cancelling} onClick={onCancel}>
            Forkast prisendring
          </Button>
        ) : (
          <Button size="small" startIcon={<Edit />} disabled={!canChange} onClick={onChange}>
            Endre pris
          </Button>
        )
      }
    >
      {prices.map((x) => (
        <InfoRow hover={false} key={x.label} icon={<Payments />} label={x.label} value={priceWithPending(x.current, x.next)} />
      ))}
      {pendingFrom && <InfoRow hover={false} icon={<Event />} label="Ny pris gjelder fra" value={formatDateOnly(pendingFrom)} />}
    </Card>
  );
}
